











































import { Vue, Component, Prop } from 'vue-property-decorator';
import AppBase from '../common/base';

@Component
export default class Signup extends AppBase {
    isLogin = false;

    created() {
        this.$store.commit('setTheme', {theme: 'signup'});
    }

    get state() {
        return this.$route.query && this.$route.query.state || '';
    }

    get r() {
        return this.$route.query && this.$route.query.r || '';
    }

    get fbpixelid() {
        return this.$route.query && this.$route.query.fbpixelid || '';
    }

    onShare() {
        (<any>window).FB.ui({
            method: 'share',
            href: window.location.href
        });
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/signup/signup.vue